module.exports = __webpack_public_path__ + "static/media/paperclip.e16adf89.svg";